var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "add-item-to-basket-overlay" } }, [
    _c("div", { staticClass: "modal fade" }, [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-xl overflow-x-hidden modal-dialog-scrollable",
          attrs: { role: "document" },
        },
        [
          _vm.basketItem
            ? _c(
                "div",
                { staticClass: "modal-content overflow-x-hidden" },
                [
                  _c(
                    "div",
                    {
                      class: [
                        "modal-header d-flex justify-content-start",
                        { "no-body-content": _vm.isModalBodyEmpty },
                      ],
                    },
                    [
                      _c("img", {
                        staticClass:
                          "basketItemImage img-fluid float-left mr-2",
                        attrs: {
                          src: _vm.basketItem.variation.data.images.all[0]
                            .urlPreview,
                          alt: _vm.basketItem.variation.data.images.all[0].names
                            .alternate,
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "d-flex flex-column" }, [
                        _c("h3", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.basketOverlayHeadline"
                              )
                            )
                          ),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v(
                            _vm._s(
                              _vm.$translate(
                                "GonserDT::Template.basketOverlayText"
                              )
                            )
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "modal-body p-0 overflow-x-hidden position-relative",
                        { "no-body-content": _vm.isModalBodyEmpty },
                      ],
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("gonser-box", {
                            attrs: { isBasketOverlay: true },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._t("additionalContent"),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: [
                        "modal-footer",
                        { "no-body-content": _vm.isModalBodyEmpty },
                      ],
                    },
                    [
                      _c(
                        "div",
                        {
                          ref: "btnWrapper",
                          staticClass:
                            "btn-wrapper d-flex justify-content-around py-4 px-3",
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn mt-md-0 d-flex align-items-center w-100 flex-grow-1 justify-content-center mr-2",
                              attrs: {
                                type: "button",
                                "data-dismiss": "modal",
                                "aria-label": "Close",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-times mr-2",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "GonserDT::Template.basketContinueShopping"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "waiting-animation-infinite",
                                  rawName: "v-waiting-animation-infinite",
                                },
                              ],
                              staticClass:
                                "d-none d-md-flex btn btn-secondary btn-block mt-md-0 mx-md-1 flex-grow-1 justify-content-center mx-2",
                              attrs: { href: _vm.urls.basket, rel: "nofollow" },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-chevron-right mr-2",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.$translate("Ceres::Template.basket")
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "waiting-animation-infinite",
                                  rawName: "v-waiting-animation-infinite",
                                },
                              ],
                              staticClass:
                                "btn btn-success mt-md-0 d-flex align-items-center w-100 flex-grow-1 justify-content-center ml-2",
                              attrs: {
                                href: _vm.urls.checkout,
                                rel: "nofollow",
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-chevron-right mr-2",
                                attrs: { "aria-hidden": "true" },
                              }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$translate(
                                      "Ceres::Template.basketCheckout"
                                    )
                                  )
                                ),
                              ]),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._t("extendOverlayButtons"),
                  _vm._v(" "),
                  _vm._t("extendOverlayFooter"),
                ],
                2
              )
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [
        _c("i", {
          staticClass: "fa fa-times",
          attrs: { "aria-hidden": "true" },
        }),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }